/* v18: subscribe-and-save option, prices and schedule per bundle */
(function () {
  var root = document.querySelector('#buy'); if (!root) return;
  var json = document.querySelector('[data-ws-json]'); if (!json) return;
  var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
  if (!data.hasPlan) return;
  var subBtn = root.querySelector('[data-ws-mode="sub"]'); if (!subBtn) return;
  var onceBtn = root.querySelector('[data-ws-mode="once"]');
  if (!data.subDefault && onceBtn && subBtn.getAttribute('aria-pressed') === 'true') onceBtn.click();
  function money(c) { return '£' + (c / 100).toFixed(2); }
  var oneP = root.querySelector('[data-ws-oncep]'), subP = root.querySelector('[data-ws-subp]'),
      subW = root.querySelector('[data-ws-subwas]'), desc = root.querySelector('[data-ws-subdesc]');
  function sync() {
    var on = 0;
    root.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) { if (b.classList.contains('is-on')) on = i; });
    var v = data.variants[on]; if (!v) return;
    if (oneP) oneP.textContent = money(v.price);
    var has = !!(v.planId && v.planPrice);
    subBtn.hidden = !has;
    if (!has) { var once = root.querySelector('[data-ws-mode="once"]'); if (subBtn.getAttribute('aria-pressed') === 'true' && once) once.click(); return; }
    if (subP) subP.textContent = money(v.planPrice);
    if (subW) subW.textContent = v.planPrice < v.price ? money(v.price) : '';
    if (desc) {
      var n = v.planName ? v.planName.charAt(0).toUpperCase() + v.planName.slice(1) : '';
      desc.textContent = v.qty + (v.qty > 1 ? ' bottles' : ' bottle') + (n ? ' · ' + n : '');
    }
  }
  sync();
  new MutationObserver(sync).observe(root, { attributes: true, subtree: true, attributeFilter: ['class'] });
})();
